import {
    LoggerStore,
    MetadataStore,
} from './configStores';

class Logger {
    constructor(component) {
        this.component = component;
    }

    debug() {
        this._sendMessage('debug', arguments);
    }

    log() {
        this._sendMessage('log', arguments);
    }

    info() {
        this._sendMessage('info', arguments);
    }

    warn() {
        this._sendMessage('warn', arguments);
    }

    error() {
        this._sendMessage('error', arguments);
    }

    event() {
        this._sendMessage('event', arguments);
    }

    _sendMessage(level, args) {
        const loggers = level === 'event'
            ? [LoggerStore.getEventLogger()]
            : LoggerStore.getAllThatSupportLevel(level);

        loggers.forEach((logger) => logger[level](
            this.component,
            ...args,
            MetadataStore.compute(),
        ));
    }
}

export { Logger };
export default Logger;
